module.exports = __webpack_public_path__ + "img/ship.dac85b56.svg";